import { render, staticRenderFns } from "./IpsNav.vue?vue&type=template&id=45892104&"
import script from "./IpsNav.vue?vue&type=script&lang=js&"
export * from "./IpsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports